import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

import { DEPARTURE_DAY_SEARCH_PARAMS_KEY } from '../routes/_authenticated._main.trips/TripDepartureAtFilter';
import { PANEL_SEARCH_PARAMS_KEY } from '../routes/_authenticated._main.trips/TripPanelFilter';
import { STATE_SEARCH_PARAMS_KEY } from '../routes/_authenticated._main.trips/TripStateFilter';
import { TO_ASSIGN_SEARCH_PARAMS_KEY } from '../routes/_authenticated._main.trips/TripToAssignFilter';

export const useTripsFilters = () => {
  const [_, setSearchParams] = useSearchParams();

  const handleChange = useCallback(
    (key: string, value: string | undefined) => {
      if (value != null) {
        setSearchParams(params => {
          params.set(key, value);
          params.delete(TO_ASSIGN_SEARCH_PARAMS_KEY);
          params.delete('page');
          return params;
        });
      } else {
        setSearchParams(params => {
          params.delete(key);
          params.delete(TO_ASSIGN_SEARCH_PARAMS_KEY);
          params.delete('page');
          return params;
        });
      }
    },
    [setSearchParams],
  );

  const handleStrictChange = useCallback(
    (key: string, value: string | undefined) => {
      if (value != null) {
        setSearchParams({ [key]: value });
      } else {
        setSearchParams(undefined);
      }
    },
    [setSearchParams],
  );

  const handleReset = () => {
    setSearchParams(params => {
      params.delete(STATE_SEARCH_PARAMS_KEY);
      params.delete(DEPARTURE_DAY_SEARCH_PARAMS_KEY);
      params.delete(PANEL_SEARCH_PARAMS_KEY);
      params.delete(TO_ASSIGN_SEARCH_PARAMS_KEY);
      params.delete('page');
      return params;
    });
  };
  return { handleChange, handleStrictChange, handleReset };
};
